import { render, staticRenderFns } from "./LmPowerPoint.vue?vue&type=template&id=9bb42f6a&scoped=true&"
import script from "./LmPowerPoint.vue?vue&type=script&lang=js&"
export * from "./LmPowerPoint.vue?vue&type=script&lang=js&"
import style0 from "./LmPowerPoint.vue?vue&type=style&index=0&id=9bb42f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb42f6a",
  null
  
)

export default component.exports